import { styled } from 'stitches.config'

export const RecipeRoot = styled('div', {
  width: '100%',
  '@bp2': {},

  '& strong': {
    fontWeight: '$semiBold',
  },
})

export const SectionTitle = styled('h2', {
  color: '$primary-500',
  fontWeight: '$semiBold',
  fontSize: '$h2',
  letterSpacing: '1px',
  textAlign: 'center',
  lineHeight: '$h1',

  '@bp3': {
    fontSize: '$h1',
    textAlign: 'left',
  },

  variants: {
    align: {
      center: {
        textAlign: 'center',
        '@bp3': { textAlign: 'center' },
      },
    },
  },
})

export const Subtitle = styled('h3', {
  color: '$accent-black',
  fontWeight: '$semiBold',
  fontSize: '$h4',
  letterSpacing: '1px',
  textAlign: 'center',
  lineHeight: '$h4',
  marginTop: '24px',
})
